import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import CompareText from 'modules/payroll_bundle/components/CompareText'
import { formatAmount } from 'modules/payroll_bundle/lib/formatNumber'
import {
  getResultConceptItem,
  getResultRowDataDiffAmountInCents,
} from 'modules/payroll_bundle/lib/resultsTableData'
import type { ResultRowData } from 'modules/payroll_bundle/lib/resultsTableData'

interface Props {
  resultRowData: ResultRowData
  conceptId: number
  currency: string
  width: number
  currentPolicyPeriodId: number
  previousPolicyPeriodId?: number
}

const Cell = ({
  resultRowData,
  conceptId,
  currency,
  width,
  currentPolicyPeriodId,
  previousPolicyPeriodId,
}: Props) => {
  const currentAmountInCents =
    getResultConceptItem(resultRowData, conceptId, currentPolicyPeriodId)?.amount ?? null

  if (currentAmountInCents === null) {
    return (
      <Table.Cell width={width}>
        <Box flexDirection="column" gap="s4">
          <Text.Normal size="200" color="grey1000">
            -
          </Text.Normal>
        </Box>
      </Table.Cell>
    )
  }

  const diffAmountInCents = !previousPolicyPeriodId
    ? null
    : getResultRowDataDiffAmountInCents(
        resultRowData,
        conceptId,
        currentPolicyPeriodId,
        previousPolicyPeriodId
      )

  return (
    <Table.Cell width={width}>
      <Box flexDirection="column" gap="s4">
        <Text.Normal size="200" color="grey1000">
          {formatAmount(currentAmountInCents, currency)}
        </Text.Normal>
        {diffAmountInCents !== null && (
          <CompareText amount={Math.round(diffAmountInCents)} currency={currency} />
        )}
      </Box>
    </Table.Cell>
  )
}

// Using mobx observer because of the CompareText component
export default observer(Cell)
